import { format, startOfWeek, startOfMonth } from 'date-fns';
import type { DatePreset, AnalyticsDateSelection } from '../types/analytics';

export function presetToDateRange(selection: AnalyticsDateSelection): { dateFrom?: string; dateTo?: string } {
  const today = format(new Date(), 'yyyy-MM-dd');

  switch (selection.preset) {
    case 'all_time':
      return {};
    case 'today':
      return { dateFrom: today, dateTo: today };
    case 'this_week':
      return { dateFrom: format(startOfWeek(new Date(), { weekStartsOn: 1 }), 'yyyy-MM-dd'), dateTo: today };
    case 'this_month':
      return { dateFrom: format(startOfMonth(new Date()), 'yyyy-MM-dd'), dateTo: today };
    case 'custom':
      return { dateFrom: selection.dateFrom, dateTo: selection.dateTo };
  }
}

export function getDefaultCustomRange(): { dateFrom: string; dateTo: string } {
  return {
    dateFrom: format(startOfMonth(new Date()), 'yyyy-MM-dd'),
    dateTo: format(new Date(), 'yyyy-MM-dd'),
  };
}

export const DATE_PRESETS: { value: DatePreset; label: string }[] = [
  { value: 'all_time', label: 'All Time' },
  { value: 'today', label: 'Today' },
  { value: 'this_week', label: 'This Week' },
  { value: 'this_month', label: 'This Month' },
  { value: 'custom', label: 'Custom' },
];
